import { WebApiError } from "@faire/web-api--source/WebApiError";
import { isError } from "./typescriptUtils";
var pleaseTryAgain = function(strictLocalize) {
    return strictLocalize({
        id: "DsHyba",
        defaultMessage: [
            {
                type: 0,
                value: "Oops, something went wrong! Please try again."
            }
        ]
    });
};
var pleaseContactSupport = function(strictLocalize) {
    return strictLocalize({
        id: "RiUUHM",
        defaultMessage: [
            {
                type: 0,
                value: "Oops, something went wrong! Please contact support."
            }
        ]
    });
};
var pleaseRefreshThePage = function(strictLocalize) {
    return strictLocalize({
        id: "O5QR6m",
        defaultMessage: [
            {
                type: 0,
                value: "Oops, something went wrong! Please refresh the page."
            }
        ]
    });
};
var pleaseTryAgainOrContactSupport = function(strictLocalize) {
    return strictLocalize({
        id: "LxY31D",
        defaultMessage: [
            {
                type: 0,
                value: "Oops, something went wrong! Please try again or contact support."
            }
        ]
    });
};
var pleaseRefreshAndTryAgain = function(strictLocalize) {
    return strictLocalize({
        id: "dVFBhF",
        defaultMessage: [
            {
                type: 0,
                value: "Oops, something went wrong! Please refresh and try again."
            }
        ]
    });
};
export var ErrorMessages;
(function(ErrorMessages) {
    ErrorMessages[ErrorMessages["PLEASE_TRY_AGAIN"] = 0] = "PLEASE_TRY_AGAIN";
    ErrorMessages[ErrorMessages["PLEASE_CONTACT_SUPPORT"] = 1] = "PLEASE_CONTACT_SUPPORT";
    ErrorMessages[ErrorMessages["PLEASE_REFRESH_THE_PAGE"] = 2] = "PLEASE_REFRESH_THE_PAGE";
    ErrorMessages[ErrorMessages["PLEASE_TRY_AGAIN_OR_CONTACT_SUPPORT"] = 3] = "PLEASE_TRY_AGAIN_OR_CONTACT_SUPPORT";
    ErrorMessages[ErrorMessages["PLEASE_REFRESH_AND_TRY_AGAIN"] = 4] = "PLEASE_REFRESH_AND_TRY_AGAIN";
})(ErrorMessages || (ErrorMessages = {}));
export var getErrorMessage = function(strictLocalize, messageType) {
    var errorMessage;
    switch(messageType){
        case ErrorMessages.PLEASE_TRY_AGAIN:
            errorMessage = pleaseTryAgain(strictLocalize);
            break;
        case ErrorMessages.PLEASE_CONTACT_SUPPORT:
            errorMessage = pleaseContactSupport(strictLocalize);
            break;
        case ErrorMessages.PLEASE_REFRESH_THE_PAGE:
            errorMessage = pleaseRefreshThePage(strictLocalize);
            break;
        case ErrorMessages.PLEASE_TRY_AGAIN_OR_CONTACT_SUPPORT:
            errorMessage = pleaseTryAgainOrContactSupport(strictLocalize);
            break;
        case ErrorMessages.PLEASE_REFRESH_AND_TRY_AGAIN:
            errorMessage = pleaseRefreshAndTryAgain(strictLocalize);
            break;
        default:
            errorMessage = pleaseTryAgain(strictLocalize);
    }
    return errorMessage;
};
export var getWebApiErrorMessage = function(error, strictLocalize, fallbackErrorMessage) {
    var message = fallbackErrorMessage !== null && fallbackErrorMessage !== void 0 ? fallbackErrorMessage : getErrorMessage(strictLocalize);
    /**
     * OR operater ("||") used here instead of null coalescing operator ("??")
     * to handle empty strings
     * */ if (error instanceof WebApiError) {
        message = error.responseData.localized_message || error.responseData.message || message;
    } else if (isError(error)) {
        message = error.message || message;
    }
    return message;
};
